import {Component} from '@angular/core';
import {
    ActionSheetController,
    AlertController,
    IonicPage,
    LoadingController,
    MenuController,
    ModalController,
    NavController,
    NavParams,
    Platform,
    ToastController
} from 'ionic-angular';
import {ServiceProvider} from "../../providers/service/service";
import {Storage} from "@ionic/storage";
import {SocialSharing} from "@ionic-native/social-sharing";
import {DataCallLogPage} from "../data-call-log/data-call-log";
import {EnquiryFormPage} from "../enquiry-form/enquiry-form";
import {ListDataModelPage} from "../list-data-model/list-data-model";
import {SubStatusHistoryPage} from "../sub-status-history/sub-status-history";


@Component({
  selector: 'page-archived-data-testing-data',
  templateUrl: 'archived-data-testing-data.html',
})
export class ArchivedDataTestingDataPage {

  FUserId:any;
  School='All';
  SchoolData = {};
  EnquiryData:any;
  EnquiryData1:any;

  SubStatus: any;
  SubStatusItem: any;

  AllArchiveCount:any;
  GWEArchiveCount:any;
  GWWArchiveCount:any;
  GEISArchiveCount:any;

  constructor(public actionSheetCtrl: ActionSheetController,
              public navCtrl: NavController,
              public navParams: NavParams,
              public service: ServiceProvider,
              public platform: Platform,
              menuCtrl: MenuController,
              public loadingCtrl: LoadingController,
              public storage: Storage,
              public modalCtrl: ModalController,
              public alertCtrl: AlertController,
              private socialSharing: SocialSharing) {
    this.platform.ready().then(() => {
      Promise.all([this.storage.get('LoginData'), this.storage.get('AllotedMobileNumber')]).then(values => {
        this.FUserId = values[0]['FUserId'];

        this.SchoolData = {
          "All": 0,
          "GWW": 2,
          "GWE": 3,
          "GEIS": 1
        };

        this.loadvalues(this.SchoolData[this.School]);

      })
    })
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ArchivedDataRegardingJobPage');
  }

  active_tab(tab) {
    console.log(tab);
    this.School = tab;
    this.loadvalues(this.SchoolData[this.School]);
  }

  loadvalues(School) {

      this.EnquiryData1=[];
      this.EnquiryData=[];
    let loading = this.loadingCtrl.create({
      content: 'Loading'
    });
    loading.present();
    let url = 'app_web_service/get_web_enquiry_data_by_active_bit?Active=4&FSchoolId='+School+'&FUserId='+this.FUserId;

    this.service.httpcall(url).subscribe(data => {

      loading.dismiss();

      console.log(data);
      if (data['response'] == "success") {
        this.AllArchiveCount=data['AllArchiveCount'];
        this.GWEArchiveCount=data['GWEArchiveCount'];
        this.GWWArchiveCount=data['GWWArchiveCount'];
        this.GEISArchiveCount=data['GEISArchiveCount'];
        this.EnquiryData1=data['data'];
        this.EnquiryData = this.EnquiryData1;
      } else {
        this.service.showAlert("Error!",data['error_description']);
      }

    },error2 => {
      loading.dismiss();
      this.service.showAlert("Warning!","Timeout!");
    })
  }

  doRefresh(refresher) {
    console.log('Begin async operation', refresher);

    this.loadvalues(this.SchoolData[this.School]);

    setTimeout(() => {
      console.log('Async operation has ended');

      refresher.complete();
    }, 2000);
  }


    open_ArchiveActionSheet(tap, item) {
        console.log("tap->", tap);

        let buttons = [];

        let CallCount = '0';
        if (item.CallCount != 0) {
            CallCount = item.CallCount;
        }

        let btn1 = {
            text: this.service.LabelCall + ' (' + CallCount + ')',
            icon: this.service.IconCall,
            handler: () => {
                console.log(this.service.LabelCall);
                this.enquiry_call(item);
            }
        }
        buttons.push(btn1);

        let btn2 = {
            text: this.service.LabelCallLogs,
            icon: this.service.IconCallLogs,
            handler: () => {
                console.log(this.service.LabelCallLogs);
                this.go_to_call_logs(item);
            }
        }
        buttons.push(btn2);

        let btn3 = {
            text: this.service.LabelSendWpMsg,
            icon: this.service.IconSendWpMsg,
            handler: () => {
                console.log(this.service.LabelSendWpMsg);
                this.whatsapp_call(item);
            }
        }
        buttons.push(btn3);

        let btn4 = {
            text: this.service.LabelSendTextMsg,
            icon: this.service.IconSendTextMsg,
            handler: () => {
                console.log(this.service.LabelSendTextMsg);
                this.msg_call(item);
            }
        }
        buttons.push(btn4);

        let btn5 = {
            text: this.service.LabelSendWpGrp,
            icon: this.service.IconSendWpGrp,
            handler: () => {
                console.log(this.service.LabelSendWpGrp);
                this.msg_Group(item);
            }
        }
        buttons.push(btn5);

        let btn6 = {
            text: this.service.LabelEditData,
            icon: this.service.IconEditData,
            handler: () => {
                console.log(this.service.LabelEditData);
                this.edit_enquiry(item);
            }
        }
        buttons.push(btn6);

        let btn7 = {
            text: this.service.LabelEditHistory,
            icon: this.service.IconEditHistory,
            handler: () => {
                console.log(this.service.LabelEditHistory);
                this.get_enquiry_log(item);
            }
        }
        buttons.push(btn7);

        let btn8 = {
            text: this.service.LabelUnArchiveData,
            icon: this.service.IconUnArchiveData,
            handler: () => {
                console.log(this.service.LabelUnArchiveData);
                this.select_Unarchive(item);
            }
        }
        buttons.push(btn8);

        let btn9 = {
            text: this.service.LabelAddSubStatus,
            icon: this.service.IconAddSubStatus,
            handler: () => {
                console.log(this.service.LabelAddSubStatus);
                this.add_SubStatus(item);
            }
        }
        buttons.push(btn9);

        let btn10 = {
            text: this.service.LabelSubStatusHist,
            icon: this.service.IconSubStatusHist,
            handler: () => {
                console.log(this.service.LabelSubStatusHist);
                this.go_to_SubStatus_hist(item);
            }
        }
        buttons.push(btn10);

        let Cancel = {
            text: this.service.LabelCancel,
            icon: this.service.IconCancel,
            handler: () => {
                console.log(this.service.LabelCancel);
            }
        }
        buttons.push(Cancel);


        this.presentActionSheet('Actions', buttons);
    }

    presentActionSheet(title, buttons) {
        const actionSheet = this.actionSheetCtrl.create({
            title: title,
            buttons
        });
        actionSheet.present();
    }

    enquiry_call(enquirydata) {

        let myAlert = this.alertCtrl.create({
            title: 'Enquiry Contacts',
            buttons: [
                {
                    text: 'Cancel',
                    role: 'cancel',
                    handler: () => {
                        console.log('Cancel clicked');
                    }
                },
                {
                    text: 'Call',
                    handler: (data) => {
                        console.log('Message clicked');
                        console.log(data);
                        // window.location.href = 'tel:'  + data;
                        let loading = this.loadingCtrl.create({
                            content: 'Loading',
                            enableBackdropDismiss: false
                        });
                        loading.present();


                        var formdata = new FormData();
                        formdata.append("FWebEnquiryId", enquirydata.Id);
                        formdata.append("AddedBy", this.FUserId);
                        formdata.append("CallTo", data);
                        formdata.append("CallType", "2");
                        formdata.append("FileName", "text");
                        // formdata.append("CallFor",this.CallFor);


                        this.service.httppostFormcall('web_service/add_enquiry_call_logs', formdata).subscribe(resdata => {
                            console.log(resdata);
                            if (resdata['response'] == 'success') {
                                var LogId = resdata['LogId'];
                                if (loading)
                                    loading.dismiss();
                                loading = undefined;

                                window.location.href = 'tel:' + data;

                                // var link="https://callrecording.page.link/?link=http%3A%2F%2Fappluswave.com%3FLogId%3D"+LogId+"%26FileName%3D"+resdata['filename']+"%26MobileNumber%3D"+data+"?/&apn=com.example.callrecording";
                                // const browser = this.iab.create(link,'_system',{location:'no'});
                                //  window.location.href="https://callrecording.page.link/?link=http%3A%2F%2Fappluswave.com%3FLogId%3D"+LogId+"%26FileName%3D"+resdata['filename']+"%26MobileNumber%3D"+data+"?/&apn=com.example.callrecording";
                            } else {
                                if (loading)
                                    loading.dismiss();
                                loading = undefined;
                            }
                        }, (err) => {
                            if (loading)
                                loading.dismiss();
                            loading = undefined;
                        });

                    }
                }
            ]
        });

        if(enquirydata.Phone1){
            myAlert.addInput({
                type: 'radio',
                label: enquirydata.Phone1,
                value: enquirydata.Phone1
            })
        }

        if(enquirydata.Phone2){
            myAlert.addInput({
                type: 'radio',
                label: enquirydata.Phone2,
                value: enquirydata.Phone2
            })
        }
        myAlert.present();

    }

    whatsapp_call(enquirydata) {

        let myAlert = this.alertCtrl.create({
            title: 'Enquiry Contacts',
            buttons: [
                {
                    text: 'Cancel',
                    role: 'cancel',
                    handler: () => {
                        console.log('Cancel clicked');
                    }
                },
                {
                    text: 'Whatsapp',
                    handler: (data) => {
                        console.log('Message clicked');
                        console.log(data);
                        window.location.href = 'whatsapp://send?phone=+91' + data;
                    }
                }
            ]
        });

        if(enquirydata.Phone1){
            myAlert.addInput({
                type: 'radio',
                label: enquirydata.Phone1,
                value: enquirydata.Phone1
            })
        }

        if(enquirydata.Phone2){
            myAlert.addInput({
                type: 'radio',
                label: enquirydata.Phone2,
                value: enquirydata.Phone2
            })
        }

        myAlert.present();


    }

    msg_call(enquirydata) {

        let myAlert = this.alertCtrl.create({
            title: 'Enquiry Contacts',
            buttons: [
                {
                    text: 'Cancel',
                    role: 'cancel',
                    handler: () => {
                        console.log('Cancel clicked');
                    }
                },
                {
                    text: 'Message',
                    handler: (data) => {
                        console.log('Message clicked');
                        console.log(data);
                        window.location.href = 'sms:' + data;
                    }
                }
            ]
        });
        if(enquirydata.Phone1){
            myAlert.addInput({
                type: 'radio',
                label: enquirydata.Phone1,
                value: enquirydata.Phone1
            })
        }

        if(enquirydata.Phone2){
            myAlert.addInput({
                type: 'radio',
                label: enquirydata.Phone2,
                value: enquirydata.Phone2
            })
        }

        myAlert.present();
    }

    msg_Group(item) {

        this.socialSharing.shareViaWhatsApp(item.SendWhatsAppGroupMsg, null, null);

    }

    go_to_call_logs(item) {
        let Call_logs_model = this.modalCtrl.create(DataCallLogPage, {data: item, Tab: 1});
        // AppointmentModel.onDidDismiss(data => {
        //   console.log(data);
        // });
        Call_logs_model.present();
    }

    edit_enquiry(item) {
        let EnquiryModel = this.modalCtrl.create(EnquiryFormPage, {editData: item, IsAppointment: 0});
        EnquiryModel.onDidDismiss(data => {
            console.log(data);

            this.loadvalues(this.SchoolData[this.School]);
            this.service.showToast(data);
        });
        EnquiryModel.present();
    }

    get_enquiry_log(item) {

        this.service.httpcall('web_service/get_web_enquiry_by_school_id?FWebEnquiryId=' + item.Id).subscribe(data => {

            console.log(data);
            if (data['response'] == "success") {
                let ListModel = this.modalCtrl.create(ListDataModelPage, {data: data['data'], title: "History"});
                ListModel.onDidDismiss(data => {
                    console.log(data);

                    this.loadvalues(this.SchoolData[this.School]);
                    this.service.showToast(data);
                });
                ListModel.present();
            } else {
                this.service.showToast(data['error_description']);
            }

        })


    }

    select_Unarchive(item) {
        let loading = this.loadingCtrl.create({
            content: 'Loading'
        });
        loading.present();

        console.log("Id", item.Id);
        this.service.httpcall('app_web_service/unArchive_EnquiryData?FUserId=' + this.FUserId + '&FWebEnquiryId=' + item.Id).subscribe(data => {
            if (loading)
                loading.dismiss();
            loading = undefined;
            console.log(data);
            if (data['response'] == "success") {
                this.service.showToast(data['success_message']);
            } else {
                this.service.showToast(data['error_description']);
            }
        })
    }

    add_SubStatus(item) {

        this.SubStatus = null;
        this.SubStatusItem = null;
        this.service.httpcall('web_service/get_master_enquiry_substatus?params[FStatusId]=' + item.Status).subscribe(data => {
            console.log("getReasons", data);
            if (data['response'] == "success") {
                this.SubStatus = data['data'];
                console.log(this.SubStatus);
                let myAlert = this.alertCtrl.create({
                    title: 'Set SubStatus',
                    buttons: [
                        {
                            text: 'Cancel',
                            role: 'cancel',
                            handler: () => {
                                console.log('Cancel clicked');
                            }
                        },
                        {
                            text: 'Confirm',
                            handler: (data) => {
                                console.log('clicked');
                                console.log(data);

                                this.service.httpcall('web_service/add_subStatus_On_webEnquiryId?FStatusId=' + item.Status + '&FWebEnquiryId=' + item.Id + '&FUserId=' + this.FUserId + '&FSubStatusId=' + data).subscribe(data => {
                                    console.log(data);
                                    if (data['response'] == "success") {
                                        this.service.showToast(data['success_message']);
                                        this.loadvalues(this.SchoolData[this.School]);
                                    } else {
                                        this.service.showToast(data['error_description']);
                                    }

                                }, (error2 => {
                                    this.service.showToast("Timeout!");
                                }))

                            }
                        }
                    ]
                });
                for (var i = 0; i < this.SubStatus.length; i++) {
                    this.SubStatusItem = this.SubStatus[i];
                    var edata = this.SubStatusItem.SubStatusName;
                    console.log(edata);
                    myAlert.addInput({
                        type: 'radio',
                        label: edata,
                        value: this.SubStatusItem.Id
                    })
                }

                myAlert.present();
            } else {
                this.service.showToast(data['error_description']);

            }

        }, (error2 => {
            this.service.showToast("Timeout!");

        }))


    }

    go_to_SubStatus_hist(item) {
        let SubStatusHistory = this.modalCtrl.create(SubStatusHistoryPage, {FWebEnquiryId: item.Id});
        SubStatusHistory.onDidDismiss(data => {
            console.log(data);
        });
        SubStatusHistory.present();
    }
}



// WEBPACK FOOTER //
// ./src/pages/archived-data-testing-data/archived-data-testing-data.ts